<template>
  <div>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else>
      <template v-if="possibleOutput && possibleOutput.length > 0">
        <multiselect
          v-model="caseB"
          :options="possibleOutput"
          :allow-empty="false"
          :searchable="false"
          selectLabel
          selectedLabel
          deselect-label
          @input="onChange"
        ></multiselect>
      </template>
      <template v-else>
        <template v-if="possibleOutput && possibleOutput.length > 0 && isAutofill">
          <multiselect
            v-model="caseB"
            :options="possibleOutput"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            @input="onChange"
          ></multiselect>
        </template>
        <template v-else>
          <v-layout>
            <v-flex>
              <template v-if="showVariableList == 'true'">
                <div class="text-xs-center" v-if="loadingVariableList">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <multiselect
                  v-else
                  v-model="selectVaraible"
                  :options="variables"
                  :allow-empty="false"
                  :searchable="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                  @input="onChangeVariable"
                  track-by="value"
                  label="text"
                ></multiselect>
              </template>
              <input type="text" v-model="caseB" @blur="onChangeInput" v-else />
            </v-flex>
            <v-flex shrink>
              <v-checkbox
                class="mt-2"
                label=""
                v-model="showVariableList"
                value="true"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </template>
        <v-checkbox
          v-if="possibleOutput && possibleOutput.length > 0"
          v-model="isAutofill"
          color="primary"
          class="ma-2"
          style="display: inline-block;"
        ></v-checkbox>
      </template>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'datatype'],
  data() {
    return {
      caseB: '',
      possibleOutput: [],
      loading: true,
      isAutofill: false,
      showVariableList: null
    }
  },
  computed: {
    ...mapGetters({
      loadingVariableList: 'getLoadingVariableList'
    }),
    selectVaraible: {
      get() {
        let variable = null
        try {
          variable = this.variables.find(el => el.value == this.caseB)
        } catch (error) {}
        return variable
      },
      set(val) {
        if (val.value) {
          this.caseB = val.value
        } else {
          this.caseB = ''
        }
      }
    },
    variables() {
      let variables = []
      try {
        if (this.$store.getters.getVariableList) {
          variables = this.$store.getters.getVariableList.map(el => ({
            value: `{${el.name}}`,
            text: el.name
          }))
        }
      } catch (error) {}
      return variables
    }
  },
  components: {
    Multiselect
  },
  mounted() {
    var vm = this
    vm.caseB = vm.value
    if (vm.caseB.match(/({[0-9aA-zZ.ก-๛]+})/gm)) {
      try {
        let variable = this.variables.find(el => el.value == this.caseB)
        if (variable) {
          this.selectVaraible = variable
          this.showVariableList = 'true'
        }
      } catch (error) {}
    }
    vm.loading = true
    api.getVariablePossibleOutput({ name: vm.datatype }, function(error, response) {
      if (error) {
        console.error(error)
        vm.loading = false
        return
      }
      if (response.responsecode == 200 && response.description != '') {
        vm.possibleOutput = response.description.split(',')
      }
      vm.loading = false
    })
  },
  methods: {
    onChangeInput() {
      var caseB = ''
      try {
        caseB = this.caseB
        if (caseB != '') {
          caseB = caseB.replace(/[=]/g, '')
          this.caseB = caseB
        }
      } catch (error) {}
      this.$emit('input', this.caseB)
      this.$emit('onChange')
    },
    onChange(type) {
      this.caseB = type
      this.$emit('input', type)
      this.$emit('onChange')
    },
    onChangeVariable(type) {
      this.selectVaraible = type
      this.$emit('input', this.caseB)
      this.$emit('onChange')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/DynamicCaseBManage.vue